// extracted by mini-css-extract-plugin
module.exports = {"root":"Auth_root__13ny4","wrapper":"Auth_wrapper__2tjJK","route":"Auth_route__1ovCF"};